import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { getPrintableInventoryName } from '../../../services/templeService'

export default function usePrintableInventoryName(pinId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [printableInventoryName, setPrintableInventoryName] = useState()

  useEffect(() => {
    let isCurrent = true
    if (pinId) {
      getPrintableInventoryName(pinId)
        .then((response) => {
          if (isCurrent) {
            setPrintableInventoryName(response.data)
          }
        })
        .catch((err) => {
          if (isCurrent) {
            const errNotification = err.response?.data?.notifications?.[0]?.msg
            error(
              `${t('hooks.errors.gettingPrintableInventoryName', 'Error getting printable inventory name')}${
                errNotification ? `: ${errNotification}` : err.message
              }`,
              err
            )
            setPrintableInventoryName()
          }
        })
    }
    return () => {
      isCurrent = false
    }
  }, [error, pinId, t])

  return printableInventoryName
}
